import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l5 5l10 -10","key":"svg-0"}]]

const IconCheck = createReactComponent('outline', 'check', 'Check', __iconNode);

export default IconCheck;